export default "__VITE_ASSET__fd854557__"